// The travel agent's screen (prototype: register.liparifoods.com/agent). Codes arrive the moment
// they are issued; this is where the name gets checked against the code before booking.
// `embedded` = shown inside the back office (admins); otherwise it is Russ's whole page.
import React, { useEffect, useState } from "react";
import { api } from "../lib/api.js";
import { PageHead, StatePill, Notice, fmtWhen } from "./admin/ui.jsx";

const method = (r) => (r.travelMethod === "B" ? `Flying${r.travellers[0]?.departCity ? ` from ${r.travellers[0].departCity}` : ""}` : "Driving");

export default function Agent({ canBook, embedded }) {
  const [data, setData] = useState({ counts: {}, codes: [] });
  const [q, setQ] = useState("");
  const [check, setCheck] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const load = async () => { try { setData(await api("/agent/codes?limit=300")); setError(null); } catch (err) { setError(err.message); } };
  useEffect(() => { load(); const t = setInterval(load, 10000); return () => clearInterval(t); }, []);

  async function lookup(e) {
    e?.preventDefault();
    const code = q.trim().toUpperCase(); if (!code) return;
    setBusy(true);
    try { setCheck({ ok: true, row: await api(`/agent/codes/${encodeURIComponent(code)}`) }); }
    catch (err) { setCheck({ ok: false, error: err.message, code }); }
    finally { setBusy(false); }
  }
  async function booked(code) {
    setBusy(true);
    try { await api(`/agent/codes/${encodeURIComponent(code)}/booked`, { method: "POST", body: {} }); await load(); if (check?.row?.code === code) await lookup(); }
    catch (err) { setError(err.message); } finally { setBusy(false); }
  }

  const Row = ({ r, detail }) => (
    <div className="bo-tr">
      <div className="mono code big">{r.code}</div>
      <div className="name"><b>{r.travellers.map(t => t.name).join(", ")}</b><div className="muted small">{r.role === "guest" ? "Guest" : "Lipari"} · {r.registrant} · {method(r)}</div>
        {detail && r.travellers.map(t => <div key={t.email} className="mono small muted">{t.name} · {t.email}{t.phone ? ` · ${t.phone}` : ""}</div>)}</div>
      <div className="muted">{fmtWhen(r.issuedAt)}</div>
      <div><StatePill state={r.agentStatus} /></div>
      <div className="actions">{canBook && r.agentStatus !== "used" && <button className="bo-link" disabled={busy} onClick={() => booked(r.code)}>Mark booked</button>}</div>
    </div>
  );

  const body = (
    <>
      <PageHead title="Check a code before you book" sub="Codes arrive here the moment they are issued. A code only works for the people named on it: if the caller's name is not against the code, do not book." />
      <form className="bo-bar check" onSubmit={lookup}>
        <input className="bo-code-input" value={q} onChange={e => setQ(e.target.value)} placeholder="BAM-000000" autoComplete="off" aria-label="Code" />
        <button className="bo-btn primary" type="submit" disabled={busy}>Check</button>
        <div className="spacer" />
        <span className="muted"><b>{data.counts.issued ?? 0}</b> issued · <b>{data.counts.booked ?? 0}</b> booked</span>
      </form>
      {check && (check.ok
        ? <div className="bo-table codes"><Notice tone="ok">Valid code. Book only for the names below.</Notice><Row r={check.row} detail /></div>
        : <Notice tone="bad">{check.code}: {check.error}</Notice>)}
      {error && <Notice tone="bad">{error}</Notice>}
      <div className="bo-table codes">
        <div className="bo-th"><div>Code</div><div>Names on it</div><div>Issued</div><div>Agent</div><div /></div>
        {data.codes.map(r => <Row key={r.code} r={r} />)}
        {!data.codes.length && <div className="bo-empty">No codes yet.</div>}
      </div>
    </>
  );
  return embedded ? body : <div className="bo"><main className="bo-main agent-page">{body}</main></div>;
}
